"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledText = exports.StyledSubHeading = exports.StyledRepresentative = exports.StyledPicture = exports.StyledParagraph = exports.StyledHeading = exports.StyledContentBanner = exports.StyledContent = exports.StyledButtons = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _gridConfig = require("../../fuse-responsive-grid/src/grid-config");
var _typography = require("../../fuse-typography-element/src/typography");
var _cb1VariantConfig = _interopRequireDefault(require("./cb1-variant-config"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledContentBanner = exports.StyledContentBanner = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['addBrandColour', 'lLayout', 'smallVariant', 'variant'].includes(prop);
  }
}).attrs({
  className: 'fuse-content-banner-1'
}).withConfig({
  displayName: "styled-content-banner-1__StyledContentBanner",
  componentId: "sc-kx7esd-0"
})(["border:none;display:grid;gap:var(--spacing-global-space5);position:relative;padding:var(--spacing-global-space6);text-align:left;text-decoration:none;", " background:", ";box-sizing:border-box;box-shadow:inset 0 0 0 var(--border-width-l) ", ";@media screen and (min-width:", "){grid-template-columns:", ";gap:var(--spacing-global-space6);align-items:start;}@media screen and (min-width:", "){padding:var(--spacing-global-space6) var(--spacing-global-space7);align-items:", ";}&:focus{outline:var(--border-radius-s) solid var(--color-functional-focus);outline-offset:-2px;}&:active{.fuse-content-banner-1__primary-span-cta{box-shadow:inset 0 0 0 var(--border-radius-s) var(--color-global-white);color:var(--color-brand-mid);background-color:var(--color-global-white);}.fuse-content-banner-1__primary-span-cta:before{background:var(--color-brand-mid);}}&:hover{.fuse-content-banner-1__primary-span-cta{border:1px solid var(--color-brand-mid);box-shadow:var(--elevation-shadow-s);}}"], function (props) {
  return props.as === 'button' ? "\n\t\tcursor: pointer;\n\t" : "";
}, function (_ref) {
  var addBrandColour = _ref.addBrandColour,
    smallVariant = _ref.smallVariant,
    variant = _ref.variant;
  return addBrandColour && smallVariant ? _cb1VariantConfig["default"][variant].background.smallSize : _cb1VariantConfig["default"][variant].background["default"];
}, function (_ref2) {
  var variant = _ref2.variant;
  return _cb1VariantConfig["default"][variant].border;
}, _gridConfig.gridConfig.m.minWidth, function (props) {
  return props.image ? 'max-content 1fr' : '1fr';
}, _gridConfig.gridConfig.l.minWidth, function (_ref3) {
  var lLayout = _ref3.lLayout;
  return lLayout === 'v1' ? 'normal' : 'start';
});
var StyledPicture = exports.StyledPicture = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['imageSize', 'lLayout'].includes(prop);
  }
}).attrs({
  className: 'fuse-content-banner-1__picture',
  'data-testid': 'fuse-content-banner-1-picture-test-id'
}).withConfig({
  displayName: "styled-content-banner-1__StyledPicture",
  componentId: "sc-kx7esd-1"
})(["display:grid;position:relative;align-self:start;width:", ";aspect-ratio:", ";@media screen and (min-width:", "){width:calc(", " * 1.6rem);}@media screen and (min-width:", "){width:calc( ", " * 1.6rem );}", " .fuse-picture{display:grid;}.fuse-picture__img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;}"], function (_ref4) {
  var imageSize = _ref4.imageSize;
  return imageSize === 'small' ? 'calc(7.5 * 1.6rem)' : '100%';
}, function (_ref5) {
  var imageSize = _ref5.imageSize;
  return imageSize === 'small' ? '4/3' : '16/9';
}, _gridConfig.gridConfig.m.minWidth, function (_ref6) {
  var imageSize = _ref6.imageSize;
  return imageSize === 'small' ? '8.5' : '16.9';
}, _gridConfig.gridConfig.l.minWidth, function (_ref7) {
  var imageSize = _ref7.imageSize,
    lLayout = _ref7.lLayout;
  return imageSize === 'small' ? "".concat(lLayout === 'v1' ? '10' : '8.5') : '16.9';
}, function (_ref8) {
  var smallVariant = _ref8.smallVariant;
  return smallVariant && "\n\t\t\t&& {\n\t\t\t\t@media screen and (max-width: ".concat(_gridConfig.gridConfig.m.maxWidth, ") {\n\t\t\t\t\twidth: calc(7.5 * 1.6rem);\n\t\t\t\t\taspect-ratio: 4/3;\n\t\t\t\t}\n\t\t\t}\n\t\t");
});
var StyledContent = exports.StyledContent = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['lLayout'].includes(prop);
  }
}).attrs({
  className: 'fuse-content-banner-1__content',
  'data-testid': 'fuse-content-banner-1-content-test-id'
}).withConfig({
  displayName: "styled-content-banner-1__StyledContent",
  componentId: "sc-kx7esd-2"
})(["display:grid;gap:var(--spacing-global-space6);", ""], function (_ref9) {
  var lLayout = _ref9.lLayout;
  return lLayout === 'v1' ? "\n\t@media screen and (min-width: ".concat(_gridConfig.gridConfig.l.minWidth, ") {\n\t\tgrid-template-columns: 1fr max-content;\n\t\tgap: var(--spacing-global-space9);\n\t}\n\t") : '';
});
var StyledText = exports.StyledText = _styledComponents["default"].div.attrs({
  className: 'fuse-content-banner-1__text',
  'data-testid': 'fuse-content-banner-1-text-test-id'
}).withConfig({
  displayName: "styled-content-banner-1__StyledText",
  componentId: "sc-kx7esd-3"
})(["display:grid;align-self:start;gap:var(--spacing-global-space2);"]);
var StyledHeading = exports.StyledHeading = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['addBrandColour', 'smallVariant', 'variant'].includes(prop);
  }
}).attrs({
  className: 'fuse-content-banner-1__heading',
  'data-testid': 'fuse-content-banner-1-heading-test-id'
}).withConfig({
  displayName: "styled-content-banner-1__StyledHeading",
  componentId: "sc-kx7esd-4"
})(["&&{color:", ";"], function (_ref10) {
  var addBrandColour = _ref10.addBrandColour,
    smallVariant = _ref10.smallVariant,
    variant = _ref10.variant;
  if (addBrandColour === 'heading') {
    if (smallVariant) {
      return _cb1VariantConfig["default"][variant].addBrandText.smallSize;
    }
    return _cb1VariantConfig["default"][variant].addBrandText["default"];
  }
  return _cb1VariantConfig["default"][variant].baseText.headings;
});
var StyledSubHeading = exports.StyledSubHeading = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['addBrandColour', 'smallVariant', 'variant'].includes(prop);
  }
}).attrs({
  className: 'fuse-content-banner-1__sub-heading',
  'data-testid': 'fuse-content-banner-1-sub-heading-test-id'
}).withConfig({
  displayName: "styled-content-banner-1__StyledSubHeading",
  componentId: "sc-kx7esd-5"
})(["&&{color:", ";"], function (_ref11) {
  var addBrandColour = _ref11.addBrandColour,
    smallVariant = _ref11.smallVariant,
    variant = _ref11.variant;
  if (addBrandColour === 'subHeading') {
    if (smallVariant) {
      return _cb1VariantConfig["default"][variant].addBrandText.smallSize;
    }
    return _cb1VariantConfig["default"][variant].addBrandText["default"];
  }
  return _cb1VariantConfig["default"][variant].baseText.headings;
});
var StyledParagraph = exports.StyledParagraph = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['variant'].includes(prop);
  }
}).attrs({
  className: 'fuse-content-banner-1__paragraph',
  'data-testid': 'fuse-content-banner-1-paragraph-test-id'
}).withConfig({
  displayName: "styled-content-banner-1__StyledParagraph",
  componentId: "sc-kx7esd-6"
})(["&&{color:", ";margin-bottom:0;}"], function (_ref12) {
  var variant = _ref12.variant;
  return _cb1VariantConfig["default"][variant].baseText.paragraphs;
});
var StyledRepresentative = exports.StyledRepresentative = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['addBrandColour', 'smallVariant', 'variant'].includes(prop);
  }
}).attrs({
  className: 'fuse-content-banner-1__representative-text',
  'data-testid': 'fuse-content-banner-1-representative-text-test-id'
}).withConfig({
  displayName: "styled-content-banner-1__StyledRepresentative",
  componentId: "sc-kx7esd-7"
})(["&&{color:", ";span.fuse-content-banner-1__wrap-apr{display:inline-flex;}"], function (_ref13) {
  var addBrandColour = _ref13.addBrandColour,
    smallVariant = _ref13.smallVariant,
    variant = _ref13.variant;
  if (addBrandColour === 'representative') {
    if (smallVariant) {
      return _cb1VariantConfig["default"][variant].addBrandText.smallSize;
    }
    return _cb1VariantConfig["default"][variant].addBrandText["default"];
  }
  return _cb1VariantConfig["default"][variant].baseText.headings;
});
var StyledButtons = exports.StyledButtons = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['lLayout'].includes(prop);
  }
}).attrs({
  className: 'fuse-content-banner-1__buttons',
  'data-testid': 'fuse-content-banner-1-buttons-test-id'
}).withConfig({
  displayName: "styled-content-banner-1__StyledButtons",
  componentId: "sc-kx7esd-8"
})(["display:flex;flex-wrap:wrap;gap:var(--spacing-global-space5);align-self:center;@media screen and (min-width:", "){flex-direction:", ";}&.fuse-content-banner-1__buttons--stacked{flex-direction:column;width:fit-content;}.fuse-content-banner-1__primary-cta--stacked,.fuse-content-banner-1__secondary-cta--stacked{width:100%;}"], _gridConfig.gridConfig.l.minWidth, function (_ref14) {
  var lLayout = _ref14.lLayout;
  return lLayout === 'v1' ? 'column' : 'row';
});